import * as Sentry from '@sentry/react';
import api from 'api';
import store from 'store';

import getProjectId from 'utils/url/getProjectId';
import getProjectState from 'store/getProjectState';
import setProjectState from 'store/setProjectState';
import buildRunsPath, { IRunsParams } from 'store/buildRunsPath';
import { makeFetchGate } from 'store/fetchRunsGate';

import { IProjectState } from 'store';
import IAsync from 'types/IAsync';
import IPaginatedResponse from 'types/IPaginatedResponse';
import IRunEntry from 'types/IRunEntry';

function setRunsAsync(projectId: string, runsAsync: IAsync<IPaginatedResponse<IRunEntry>>) {
  setProjectState(projectId, (state: IProjectState) => {
    return {
      ...state,
      runsAsync,
    };
  });
}

const runsFetchGate = makeFetchGate();

export default function fetchRuns(params: IRunsParams = {}) {
  const projectId = getProjectId();
  if (!projectId) return;

  const url = buildRunsPath(projectId, params);
  const async = getProjectState(store.getState(), projectId).runsAsync;
  const begun = runsFetchGate.begin(`${projectId}:${url}`, async.status);
  if (begun.skip) return;

  if (begun.nextStatus === 'REFRESH' && (async.status === 'SUCCESS' || async.status === 'REFRESH')) {
    setRunsAsync(projectId, { status: 'REFRESH', data: async.data });
  } else {
    setRunsAsync(projectId, { status: 'PENDING' });
  }

  api
    .get(url)
    .json()
    .then(
      (data) => {
        if (!runsFetchGate.isCurrent(begun.generation)) return;
        setRunsAsync(projectId, {
          status: 'SUCCESS',
          data: data as IPaginatedResponse<IRunEntry>,
        });
      },
      (error) => {
        if (!runsFetchGate.isCurrent(begun.generation)) return;
        Sentry.captureException(error);
        setRunsAsync(projectId, { status: 'ERROR' });
      },
    );
}
